import React, { useState } from 'react';
import LoginModal from '../components/auth/LoginModal';
import RegisterModal from '../components/auth/RegisterModal';
import IconCarouselSection from '../components/home/IconCarouselSection';
import HeaderWrapper from '../components/common/HeaderWrapper';
import HomePageImage from '../assets/HomePageImage.png';
import './HomePage.css';

const HomePage = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const handleOpenLoginModal = (e) => {
    e.preventDefault();
    setShowLoginModal(true);
    setShowRegisterModal(false); // Close register modal if open
    // Optional: Disable body scroll when modal is open
    document.body.style.overflow = 'hidden';
  };
  
  const handleCloseLoginModal = () => {
    setShowLoginModal(false);
    // Re-enable body scroll when modal is closed
    document.body.style.overflow = 'auto';
  };
  
  const handleOpenRegisterModal = (e) => {
    e.preventDefault();
    setShowRegisterModal(true);
    setShowLoginModal(false); // Close login modal if open
    // Optional: Disable body scroll when modal is open
    document.body.style.overflow = 'hidden';
  };
  
  const handleCloseRegisterModal = () => {
    setShowRegisterModal(false);
    // Re-enable body scroll when modal is closed
    document.body.style.overflow = 'auto';
  };

  // Add an effect to ensure the body has the right background color and no margins
  React.useEffect(() => {
    // Set background color and prevent unnecessary scrolling
    document.body.style.backgroundColor = '#ffd024';
    document.body.style.overflowY = 'auto';
    document.documentElement.style.height = 'auto';
    
    return () => {
      // No cleanup needed
    };
  }, []);

  return (
    <div className="home-container body-font">
      {/* Main Content Area with Yellow Background */}
      <HeaderWrapper onLogin={handleOpenLoginModal} onRegister={handleOpenRegisterModal} />
      <div className="main-background home-main-background">
        <div className="content-wrapper home-content-wrapper">
          <main style={{ flex: '0 1 auto' }}>
            <section className="discover-section">
              <div className="discover-content">
                <h2 className="heading-font discover-heading">Discover your next favourite thing</h2>
              </div>
              <div className="discover-image">
                <img src={HomePageImage} alt="People discovering content" />
              </div>
            </section>
          </main>
        </div>
        
        {/* Icon Carousel Section - Inside the main-background div but full-width */}
        <IconCarouselSection />
      </div>
      
      {/* Removed Featured Posts Section - 2025-06-21 */}
      {/* <FeaturedPostsSection /> */}
      
      {/* Main Content Area with Yellow Background - Continued */}
      <div className="main-background home-main-background">
        <div className="content-wrapper home-content-wrapper">
          {/* Removed FAQ Section - 2025-06-21 */}
          {/* <FAQSection /> */}
          
          {/* <footer className="home-footer">
            <p>&copy; 2023 YourPlat4orm. All rights reserved.</p>
          </footer> */}
        </div>
      </div>
      {/* Login Modal */}
      <LoginModal isOpen={showLoginModal} onClose={handleCloseLoginModal} />
      
      {/* Register Modal */}
      <RegisterModal isOpen={showRegisterModal} onClose={handleCloseRegisterModal} />
    </div>
  );
};
export default HomePage;